<ndc-dynamic
  [ndcDynamicComponent]="props.component"
  [ndcDynamicInputs]="inputs$ | async"
  [ndcDynamicOutputs]="props.outputs"
></ndc-dynamic>
